import styled from 'styled-components';
import {
  NavItem,
} from 'react-bootstrap';

const ColoredNavItem = styled(NavItem)`

  margin: 3px 11px;

  &:hover a {
    background-color: #bdbdbd !important;
  }

  a {
    font-weight: 700;
    font-size: 12px;
    background-color: #ccc;
    color: white;
    border-radius: 20px !important;
    padding: 7px 8px 6px 16px !important;
    text-shadow: 0 1px 2px rgba(0,0,0,0.2);
  }

  &.active a {
    background-color: ${(props) => props.color} !important;
  }

  &.active .badge {
    text-shadow: none;
    color: ${(props) => props.color} !important;
    background-color: rgba(255,255,255,0.9) !important;
  }

  .badge {
    position: relative;
    top: -1px;
    margin-left: 10px !important;
    background-color: transparent;
  }
`;

export default ColoredNavItem;



// WEBPACK FOOTER //
// ./src/components/ui/ColoredNavItem.js